import type { TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';
import { parseWithEndTag } from './baseParser';

export class ItalicTagParser implements TagParser {
  tag = 'cursief_aan';

  parse(text: string) {
    const endTag = 'cursief_uit';
    const parsedTextResult = parseWithEndTag(text, endTag);

    return {
      html: `<span class="italic">${parsedTextResult.parsedText}</span>`,
      consumedLength: parsedTextResult.consumedLength,
    };
  }
}

ParserRegistry.register(new ItalicTagParser());
